import { NgModule } from '@angular/core';
import { AnyXSrcDirective, PictureXSrcDirective } from './directives/x-src.directive';


@NgModule({
    exports: [
        AnyXSrcDirective,
        PictureXSrcDirective,
    ],
    declarations: [
        AnyXSrcDirective,
        PictureXSrcDirective,
    ],
})
export class ImageModule { }
